import { useContext } from 'react';
import { STEPS } from './steps';
import { calculateTotals } from './utils';
import { filter } from 'lodash';
import { toMoney, toDateAndTime } from './filters';
import Summary from './Summary';
import WidgetContext from './WidgetContext';


export default function CartCompact() {
    const { contingents, automaticDiscountCodes, discountCodes, setStep, ticketing } = useContext(WidgetContext);
    const total = calculateTotals(contingents);
    return (
        <div className="flex-1 flex flex-col h-3/4 lg:h-full lg:py-3">
          <div className="flex-1 overflow-auto px-4 pt-2">
            <a className="text-gold underline cursor-pointer" onClick={() => setStep(STEPS.PRODUCT_SELECTION)}>zurück</a>
            {
                filter(contingents, 'count').map((contingent, ix) => (
                    <div key={contingent.id} className="flex flex-row justify-between py-2 lg:py-4">
                      {contingent.picture ? <img className="h-24 mr-3 w-auto" src={contingent.picture}/> : null}
                      <div className="flex-1">
                        <div className="text-mm md:text-lg font-bold">{contingent.name}</div>
                        <p className="">{ticketing?.subevent?.event?.title} - {toDateAndTime(ticketing.start_time)}</p>                        
                        <p>Anzahl: {contingent.count}</p>
                        {contingent.is_invite_only && <p className="text-red-500">Nur mit Code verfügbar</p>}
                      </div>
                      <div className="flex items-center text-right">
                        {toMoney(contingent.count * contingent.price_gross)}
                      </div>
                    </div>
                ))
            }
          </div>
          <div className="pb-4 border-t border-t-blue-light px-4">
            <Summary contingents={contingents} automaticDiscountCodes={automaticDiscountCodes} discountCodes={discountCodes} />
          </div>
        </div>
    );
}


